import { AppState } from '../rootReducer';

export const getIsFeeTrendsDisabled = (state: AppState): boolean => state.feeTrends.isFeeTrendsDisabled;
